import {InputAdornment, TextField} from "@mui/material";
import SearchIcon from "assets/icons/Search";

interface SearchInputProps {
  inputValue: string;
  setInputValue: (value: string) => void;
}

const SearchInput = ({inputValue, setInputValue}:SearchInputProps ) => {
  return (
    <TextField
      value={inputValue}
      onChange={(e) => setInputValue(e.target.value)}
      sx={(theme) => ({
        width: 428,
        borderRadius: 3,
        backgroundColor: 'grey.400',
        '& .MuiInputBase-input': {
          py: 1,
          height: 36,
          ...theme.typography.h7,
          '&::placeholder': {
            ...theme.typography.h7,
            color: 'grey.200'
          }
        },
        '& .MuiOutlinedInput-notchedOutline': {
          px: 2,
          border: 'none',
        },
        [theme.breakpoints.down('xl')]: {
          width: '100%'
        }

      })}
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{color: 'black.100', width: 16, height: 16}}/>
            </InputAdornment>
          ),
        },
      }}
      placeholder={'Поиск'}
    />
  )
}

export default SearchInput
